export default __webpack_public_path__ + "static/media/profileImg_1.3814299f.png";